/** Statistics page copy. EN mirrors SV until proper translations are added. */
export const pagesStatisticsSv = {
    tabs: {
        trends: 'Trendgrafer',
        scatterPlots: 'Matriser',
        issueMarket: 'Emissionsmarknaden',
        advisors: 'Rådgivare',
    },
    intro: {
        title: 'Statistik i Finance Lab',
        paragraph1: 'Genom statistikverktyget kan du filtrera, visualisera och analysera data.',
        paragraph2: 'Inledningsvis har vi introducerat ett par olika graftyper:',
        listItem1: 'Trendgrafer och matriser för företrädesemissioner',
        listItem2: 'Samt en överblick över emissionsmarknaden',
        paragraph3:
            'Filtreringarna ovan påverkar vilket innehåll som finns i graferna och tabellerna. Ställ in den tidsperiod och de inställningar som är relevanta - experiment uppmuntras.',
        paragraph4: 'Hör gärna av dig till din kontaktperson hos Finance Lab med feedback och funderingar!',
        getStarted: 'Kom igång',
    },
    trends: {
        selectChart: 'Välj graf',
        timeUnit: 'Tidsenhet',
        selectSeries: 'Välj serie',
    },
    scatter: {
        issuesTitle: 'Emissioner',
        xAxis: 'X-axeln',
        yAxis: 'Y-axeln',
        size: 'Storlek',
    },
    issueMarket: {
        selectChart: 'Välj graf',
        overview: 'Överblick',
        ongoingIssues: 'Kommande/pågående FE',
        timeUnit: 'Tidsenhet',
        yAxis: 'Y-axel',
        raisedSize: 'Rest kapital',
        offerSize: 'Sökt kapital',
    },
    advisors: {
        advisorType: 'Typ av rådgivare',
        selectAdvisorType: 'Välj rådgivartyp',
        segmentation: 'Segmentering',
        selectSegmentation: 'Välj segmentering',
        advisorCount: 'Antal rådgivare: {{count}}',
        selectAtLeastOne: 'Välj minst en typ av rådgivare för att visa statistik.',
        loading: 'Laddar...',
        noMatchingIssues: 'Inga emissioner matchar filtren för valda rådgivartyper.',
        unnamed: 'Ej namngiven',
        issueCountAxis: 'Antal emissioner',
        types: {
            financial_advisor: 'Finansiella rådgivare',
            legal_advisor: 'Legala rådgivare',
            issuing_agent: 'Emissionsinstitut',
        },
        segmentationOptions: {
            none: 'Ingen segmentering',
            issueType: 'Emissionstyp',
            offerSize: 'Emissionsstorlek',
            marketplace: 'Marknadsplats',
            year: 'Årtal',
        },
    },
}

/** Chart-specific labels for statistics views. Merged into charts.* in i18n. */
export const chartsStatisticsSv = {
    trendGraphs: {
        commitment: 'Säkerställandegrad',
        subscription: 'Utfall',
        guarantorFee: 'Garantiersättning',
        discount: 'Rabatt',
        totalCommitment: 'Tecknings- och garantiåtagande',
        commitmentOnly: 'Teckningsåtagande',
        subscriptionQuota: 'Teckningsgrad',
        subscriptionQuotaExclGuarantors: 'Teckningsgrad ex. garanter',
        feeCash: 'Kontant ersättning',
        feeUnits: 'Ersättning i aktier/units',
        discount10d: 'Rabatt mot 10 dagar VWAP',
        discount10dTerp: 'TERP-rabatt mot 10 dagar VWAP',
    },
    timeUnit: {
        quarter: 'Kvartal',
        year: 'År',
        month: 'Månad',
    },
    issueType: {
        RE: 'RE',
        FE: 'FE',
        IPO: 'IPO',
        AE: 'AE',
    },
    offerSize: {
        '0–50 MSEK': '0–50 MSEK',
        '50–200 MSEK': '50–200 MSEK',
        '200–1 000 MSEK': '200–1 000 MSEK',
        '1 000+ MSEK': '1 000+ MSEK',
    },
    scatter: {
        selectAreaHint: 'Markera ett område för att filtrera tabellen.',
        groups: {
            general: 'Allmänt',
            guarantorFee: 'Garantiersättning',
            priceChange: 'Kursutveckling',
            discounts: 'Rabatter',
            commitment: 'Säkerställande',
            outcome: 'Utfall',
        },
        axis: {
            avgTurnover: 'Omsättning / dag i SEK, innan emissionen (10d)',
            commitment: 'Teckningsåtagande ex. garanter (%)',
            dilutionActual: 'Utspädning (faktisk)',
            dilutionMax: 'Utspädning (max)',
            feeCash: 'Garantiersättning kontant (%)',
            feeUnits: 'Garantiersättning aktier/units (%)',
            offerSize: 'Storlek på emission i SEK',
            preMoney: 'Pre-money värdering',
            priceChangeMax: 'Kursutveckling Max',
            priceChange3m: 'Kursutveckling 3 mån',
            priceChange6m: 'Kursutveckling 6 mån',
            priceChange12m: 'Kursutveckling 12 mån',
            subscribedSize: 'Tecknat belopp i SEK',
            subscriptionQuota: 'Teckningsgrad (%)',
            subscriptionQuotaExclGuarantors: 'Teckningsgrad ex. garanter (%)',
            subscriptionQuotaExclGuarantorsAndCommitments: 'Andel tecknat utöver TÅ (%)',
            totalCommitment: 'Säkerställandegrad (%)',
            vwap10d: 'Rabatt mot 10 dagar VWAP (%)',
            vwap10dTerp: 'TERP-rabatt mot 10 dagar VWAP (%)',
        },
    },
}
